import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import SafeGaming from 'pages/safe-gaming';
import z from 'zod';

const safeGamingSearchSchema = z.object({
  providerCode: z.string(),
});

export const Route = createFileRoute('/_auth/safe-gaming')({
  beforeLoad: () => {
    if (window.AR_APP_COUNTRY !== 'es') throw redirect({ to: '/' });
  },
  component: SafeGaming,
  validateSearch: zodValidator(safeGamingSearchSchema),
});
